import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import withStyle from 'react-jss'
import routes from '../routing/routes'
import { PUBLIC_URL } from '../config/env'
import classNames from 'classnames'

const styles = theme => ({
  price: {
    fontWeight: theme.extraBold,
    color: theme.prix,
    fontSize: theme.tailleGrandTexte
  }
})

const Prix = ({
  classes,
  className,
  price,
  unit,
  quantity,
  pieces,
  bulksale,
  idProduct,
  noSeo
}) =>
  bulksale ? (
    <div
      {...(noSeo
        ? {}
        : {
            itemProp: 'offers',
            itemType: 'http://schema.org/Offer',
            itemScope: true
          })}
    >
      {!noSeo && (
        <Fragment>
          <link
            itemProp='url'
            href={`${PUBLIC_URL}${routes.ficheProduit.replace(
              ':idProduct(\\d+)',
              idProduct
            )}`}
          />
          <meta itemProp='availability' content='https://schema.org/InStock' />
          <meta itemProp='priceCurrency' content='EUR' />
          <meta itemProp='price' content={price || 0} />
        </Fragment>
      )}
      <p className={classNames(classes.price, className)}>
        {price !== 0 ? (unit ? `${price}€ / ${unit}` : `${price}€`) : ''}
      </p>
    </div>
  ) : (
    <div
      {...(noSeo
        ? {}
        : {
            itemProp: 'offers',
            itemType: 'http://schema.org/Offer',
            itemScope: true
          })}
    >
      {!noSeo && (
        <Fragment>
          <link
            itemProp='url'
            href={`${PUBLIC_URL}${routes.ficheProduit.replace(
              ':idProduct(\\d+)',
              idProduct
            )}`}
          />
          <meta itemProp='availability' content='https://schema.org/InStock' />
          <meta itemProp='priceCurrency' content='EUR' />
          <meta itemProp='price' content={price || 0} />
        </Fragment>
      )}
      <p className={classNames(classes.price, className)}>
        {parseFloat(price) !== 0 &&
          (parseInt(pieces) !== 0
            ? `${price}€ ${pieces < 2 ? "l'unité" : `les ${pieces}`}${
                unit && quantity > 0 && pieces > 0
                  ? ` (${quantity * pieces} ${unit})`
                  : ''
              }`
            : `${price}€ ${
                quantity > 1
                  ? `les ${quantity}${unit ? ` ${unit}` : ''}`
                  : unit && unit !== 'pièces'
                  ? `le ${unit}`
                  : 'la pièce'
              }`)}
      </p>
    </div>
  )

Prix.propTypes = {
  bulksale: PropTypes.bool,
  className: PropTypes.string,
  idProduct: PropTypes.any,
  noSeo: PropTypes.bool,
  pieces: PropTypes.any,
  price: PropTypes.any.isRequired,
  quantity: PropTypes.any,
  unit: PropTypes.string
}

export default withStyle(styles)(Prix)
